<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <payee-icon
      name="house"
      class="title-icon"
      height="73px"
      width="auto"
    ></payee-icon>
    <h1>
      {{ "WORKFLOW_DIALOGS.MISSED_INSTALLMENT_REPORT.TITLE" | translate }}
    </h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.MISSED_INSTALLMENT_REPORT.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <ng-template #payeePopupSubmitTemplate>
    <button
      class="payee-button"
      payee-button
      color="blue"
      width="max"
      height="normal"
      [disabled]="loading"
      [loading]="loading"
      (click)="submit()"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.MISSED_INSTALLMENT_REPORT.CONTINUE_LEGAL_ACTION" | translate }}
      </ng-container>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      class="payee-button"
      payee-button
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      [mat-dialog-close]="undefined"
    >
      <ng-container>
        {{ "WORKFLOW_DIALOGS.MISSED_INSTALLMENT_REPORT.CANCEL" | translate }}
      </ng-container>
    </button>
  </ng-template>
</payee-popup>
